import { ChartConfig, ChartContainer } from "design-system/molecules/Chart"
import { cn } from "design-system/utils"
import { useTranslation } from "react-i18next"
import { Cell, Label, Pie, PieChart } from "recharts"

const chartConfig = {} satisfies ChartConfig

type Props = {
  rings?: 1 | 2 | 3 | null
  mini?: boolean
}

export function PresenceScore({ rings, mini }: Props) {
  const { t } = useTranslation()

  const paintedRings: 1 | 2 | 3 = rings ?? 1
  const mutedColor = "var(--muted)"

  let paintedColor = "var(--neutral)"
  let label = t("dashboard.score.low")
  if (rings === 2) {
    paintedColor = "var(--chart-secondary)"
    label = t("dashboard.score.medium")
  } else if (rings === 3) {
    paintedColor = "var(--chart-primary)"
    label = t("dashboard.score.high")
  }

  return (
    <ChartContainer
      config={chartConfig}
      className={cn("aspect-square", mini ? "h-[14px]" : "h-[100px]")}
    >
      <PieChart>
        <Pie
          data={[{ value: 1 }]}
          dataKey="value"
          startAngle={88}
          endAngle={-28}
          innerRadius={mini ? 5 : 40}
          outerRadius={mini ? 7 : 50}
          animationDuration={0}
        >
          <Cell fill={paintedRings >= 1 ? paintedColor : mutedColor} />
          {!mini && (
            <Label
              position="center"
              content={({ viewBox }) => {
                if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                  return (
                    <text
                      x={viewBox.cx}
                      y={viewBox.cy}
                      textAnchor="middle"
                      dominantBaseline="middle"
                    >
                      <tspan
                        x={viewBox.cx}
                        y={(viewBox.cy ?? 0) - 4}
                        className="text-[10px] fill-muted-foreground"
                      >
                        {t("shared.rates.presence") + ":"}
                      </tspan>
                      <tspan
                        x={viewBox.cx}
                        y={(viewBox.cy ?? 0) + 10}
                        className="text-[10px] fill-muted-foreground"
                      >
                        {label}
                      </tspan>
                    </text>
                  )
                }
                return null
              }}
            />
          )}
        </Pie>
        <Pie
          data={[{ value: 1 }]}
          dataKey="value"
          startAngle={-32}
          endAngle={-148}
          innerRadius={mini ? 5 : 40}
          outerRadius={mini ? 7 : 50}
          animationDuration={0}
        >
          <Cell fill={paintedRings >= 2 ? paintedColor : mutedColor} />
        </Pie>
        <Pie
          data={[{ value: 1 }]}
          dataKey="value"
          startAngle={-152}
          endAngle={-268}
          innerRadius={mini ? 5 : 40}
          outerRadius={mini ? 7 : 50}
          animationDuration={0}
        >
          <Cell fill={paintedRings >= 3 ? paintedColor : mutedColor} />
        </Pie>
      </PieChart>
    </ChartContainer>
  )
}
